import React, { useState } from 'react';
import { DialogV2, AritoIcon, AritoFormV2, BottomActionBarV2 } from '@/components/custom/erp';

import { CountryFormattedData, SearchFormValues, searchSchema } from '../../schemas';
import { QuocGia } from '@/types/schemas';
import CountryForm from './CountryForm';
import { FormMode } from '@/types/form';

interface CountryDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: SearchFormValues;
  onClose: () => void;
  onSubmit?: (data: CountryFormattedData) => void;
  selectedObj?: QuocGia | null;
  updateCountry?: (uuid: string, data: CountryFormattedData) => Promise<void>;
  addCountry?: (data: CountryFormattedData) => Promise<void>;
  // Additional props for view mode actions
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

function CountryDialog({
  open,
  mode,
  initialData,
  onClose,
  onSubmit,
  selectedObj,
  updateCountry,
  addCountry,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: CountryDialogProps) {
  const handleSubmit = async (data: SearchFormValues) => {
    const formattedData: CountryFormattedData = {
      ma_qg: data.ma_qg,
      ten_qg: data.ten_qg,
      ten_qg2: data.ten_qg2 || null,
      status: data.status
    };

    try {
      if (mode === 'edit' && selectedObj && updateCountry) {
        await updateCountry(selectedObj.uuid, formattedData);
      }
      if (mode === 'add' && addCountry) {
        await addCountry(formattedData);
      } else if (onSubmit) {
        onSubmit(formattedData);
      }

      onClose();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
  const title = mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem chi tiết';

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={title}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={12} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={searchSchema}
          onSubmit={handleSubmit}
          initialData={initialData}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<CountryForm mode={mode} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default CountryDialog;
